import { useMemo } from "react";
import DrinksMenuPanel from "../drinks/DrinksMenuPanel";
import { getFoodsBoardPanels } from "../../../data/foodsMenuLayout";

function FoodMenuBoard({ lang, onOpen, vatNote }) {
  const panels = useMemo(() => getFoodsBoardPanels(lang), [lang]);

  return (
    <div className="drinks-menu-board foods-menu-board">
      <div className="foods-menu-board-grid" role="list">
        {panels.map((panel) => (
          <DrinksMenuPanel
            key={panel.id}
            panel={panel}
            lang={lang}
            onOpen={onOpen}
          />
        ))}
      </div>
      {vatNote ? <p className="drinks-menu-vat">{vatNote}</p> : null}
    </div>
  );
}

export default FoodMenuBoard;
